import { ChangeEvent } from "react"
import "./CustomInput.style.scss"

type ICustomInputProps = {
  value: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  onPaste?: (e: React.ClipboardEvent<HTMLInputElement>) => void
  ref?: (el: HTMLInputElement | null) => void
  onFocus?: () => void
  type?: "text" | "password"
  placeholder?: string
  name?: string
  error?: string
  style?: React.CSSProperties
  maxLength?: number | undefined
}

const CustomInput = ({
  value,
  onChange = () => {},
  type = "text",
  placeholder = "",
  name = "",
  error,
  style,
  onBlur,
  maxLength,
  onKeyDown,
  onFocus,
  ref,
  onPaste,
}: ICustomInputProps) => {
  return (
    <div>
      <input
        ref={ref}
        className='custom_input'
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        placeholder={placeholder}
        type={type}
        name={name}
        style={style}
        onBlur={onBlur}
        maxLength={maxLength}
        onPaste={onPaste}
      />
      {error && <p className='error_message'> {error}</p>}
    </div>
  )
}

export default CustomInput
